import { api } from 'src/plugins/axios'
import router from 'src/router'
import { notify } from 'src/plugins/notify'

export default {
  loginUser,
  logoutUser,
  submitSignupForm,
  submitLoginForm,
  verifyEmail,
  submitForgotPasswordForm,
  checkUserToken,
  submitResetPasswordForm,
  submitChangePasswordForm,
  setCurrentUser,
  $p,
  clearChangePasswordForm,
  resetState
}

async function submitSignupForm ({ dispatch, state }, payload) {
  try {
    let { data } = await api.post('/auth/signup', state.signupForm)
    const { success, message } = data
    const type = (success) ? 'positive' : 'negative'

    notify.create({ message, type })
    // dispatch('showToast', { type: type, message: message }, { root: true })
  } catch (err) {
    console.log(err)
  }
}

async function submitLoginForm ({ dispatch, state }, {banner}) {
  state.authenticating = true
  try {
    const response = await api.post('/auth/login', state.loginForm)
    const { success, message, payload } = response.data;
    
    const type = (success) ? 'positive' : 'negative'
    const token = (payload.token) ? `Bearer ${payload.token}` : ''
    if (token && success) {
      await dispatch('loginUser', { token })
      state.user = payload.user
      const userEmail = state.user.USER_EMAIL
      const updatedLoginDate = await api.post('/auth/updateLoginDate', { 'userEmail': userEmail })
      state.loginForm.password = ''
      window.sessionExpiredNotified = false

      let nextRoute = (state.redirectUrl) ? state.redirectUrl : '/students/'
      if (payload.showUserList) {
        nextRoute = (state.redirectUrl) ? state.redirectUrl : '/'
      }
      await router.push(nextRoute)
      state.redirectUrl = null
      
      // Close the banner if one was provided.
      if(banner) banner()
    }
    notify.create({ message, type })
    state.authenticating = false

    // Hotfix:
    // Sometimes the server could've been down on the login page load.
    // So we should ensure lookups are loaded again after login.
    this.dispatch('loadLookups')
  }
  catch(error){
    let message = "An error occurred during login."
    if(!error.response){
      message = "Network Error: Server Down"
    }
    notify.create({ message: message, type: "negative" })
    state.authenticating = false
  }
}

function loginUser ({ dispatch }, { token }) {
  dispatch('resetState')
  return window.localStorage.setItem('user-token', token)
}

function logoutUser ({ state, commit, dispatch }, notifyLogout = true) {
  try {
    const message = 'Logged out successfully'
    state.authenticating = false
    window.localStorage.removeItem('user-token')
    api.defaults.headers.common['Authorization'] = null
    if (notifyLogout) {
      notify.create({ message: message, type: 'positive' })
    }
    state.loginForm.password = ''
    // dispatch('showToast', { type, message }, { root: true })
    dispatch('resetState')
    window.location = '/login?logout=true'
  } catch (err) {}
}

async function verifyEmail ({ commit }, { verificationToken }) {
  const response = await api.post('/auth/verifyEmail', { verificationToken })
  const { success, message } = response.data
  const type = (success) ? 'positive' : 'negative'
  notify.create({ message, type })
}

async function submitForgotPasswordForm ({ commit, state }) {
  try {
    const { forgotPasswordForm } = state
    const { data: response } = await api.post('/auth/forgotPassword', forgotPasswordForm)
    const { success, message } = response
    const type = (success) ? 'positive' : 'negative'
    if (!success) throw response
    commit('clearForgotPasswordForm')
    notify.create({ message, type })
    return response
  } catch (err) {
    notify.respond(err)
    return err
  }
}

async function submitResetPasswordForm ({ dispatch, commit, state }, resetToken) {
  const passwordResetForm = { password: state.changePasswordForm.password, confirmPassword: state.changePasswordForm.confirmPassword, resetToken }
  try {
    const { data: response } = await api.post('/auth/resetPassword', passwordResetForm)
    console.log('response', response)
    const { success, message } = response
    const type = (success) ? 'positive' : 'negative'
    if (!success) throw response
    commit('clearChangePasswordForm')
    notify.create({ message, type })
    return response
  } catch (response) {
    notify.respond(response)
    return response
  }
}

async function checkUserToken ({ commit }, authorizationToken) {
  try {
    // await api.post('/authorization')
    return true
  } catch (err) {
    return false
  }
}

async function submitChangePasswordForm ({ dispatch, commit, state }, selectedUser) {
  const userID = selectedUser.USER_ID
  commit('updateUserChangePasswordForm', { userID })
  try {
    const { data: response } = await api.post('/auth/changePassword', state.changePasswordForm)
    const { success } = response
    const type = (success) ? 'positive' : 'negative'
    if(success) dispatch('clearChangePasswordForm')
    notify.respond(response)
    return response
  } catch (response) {
    notify.respond(response)
    return response
  }
}

async function setCurrentUser({ state, dispatch }){
  return await api.get('/auth/getCurrentUser')
  .then( ({data}) => {
    if(data.success){
      state.user = data.user
    }
    else{
      dispatch('logoutUser', false)
    }
  })
  .catch(err => {
    dispatch('logoutUser',false)
  })
}

async function $p({ state }, [ keys, checkType ]){
  let user = state.user
   // If you are not logged in, you have no permissions.
  if(!user) return false

  let or = (checkType === 'or')
  let valid = (or) ? false : true

  _.map(keys, key => {
      let roleToCheck = user.ROLES[key]
      if( or ){
          valid = (valid === true || roleToCheck) ? true : false
      }
      else{
          valid = (valid === true && roleToCheck) ? true : false
      }
  })
  return Promise.resolve(valid)
}

function clearChangePasswordForm ({ commit, state }) {
  commit('clearChangePasswordForm')
}

function resetState ({ commit, state }) {
  commit('approvals/resetState', state, { root: true })
  commit('attend/resetState', state, { root: true })
  commit('auth/resetState', state, { root: true })
  commit('certificates/resetState', state, { root: true })
  commit('classes/resetState', state, { root: true })
  commit('courses/resetState', state, { root: true })
  commit('documents/resetState', state, { root: true })
  commit('notifications/resetState', state, { root: true })
  commit('orders/resetState', state, { root: true })
  commit('reports/resetState', state, { root: true })
  commit('students/resetState', state, { root: true })
  commit('users/resetState', state, { root: true })
  //commit('shared/resetState', state, { root: true }) // TODO: This throws an error...?
}
